<template>
    <div class="width-a">
        <div class="toolsc">
            <el-button type="primary" @click="goBackTap">返回上一页</el-button>
            <el-button type="primary" @click="submitForm('mNotice')">保存配置</el-button>
        </div>
        <el-form ref="mNotice" :model="mNotice" label-width="100px">
            <el-form-item label="类型" prop="noticeType">
                <el-select class="m-input" v-model="mNotice.noticeType" placeholder="请选择" clearable>
                    <el-option label="公告" :value="1" />
                    <el-option label="系统" :value="2" />
                </el-select>
            </el-form-item>
            <el-form-item label="标题" prop="noticeTitle">
                <el-input v-model="mNotice.noticeTitle" placeholder="请输入" clearable />
            </el-form-item>
            <el-form-item label="发布时间" prop="publishTime">
                <el-date-picker
                    v-model="mNotice.publishTime"
                    class="m-input"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    type="datetime"
                    placeholder="选择日期"
                />
            </el-form-item>
            <el-form-item label="目标" prop="publishTarget">
                <el-select class="m-input" v-model="mNotice.publishTarget" placeholder="请选择" clearable>
                    <el-option label="所有人" :value="0" />
                    <el-option label="教师" :value="1" />
                    <el-option label="学生" :value="2" />
                    <el-option label="自定义" :value="3" />
                </el-select>
            </el-form-item>
            <el-form-item label="内容" prop="noticeContent">
                <div ref="editor"></div>
            </el-form-item>
            <el-form-item label="发送方式" prop="noticeContent">
                <el-radio-group v-model="mNotice.sendNoticeIs">
                    <el-radio :label="true">站内信</el-radio>
                    <el-radio :label="false">短信</el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </div>
</template>

<script>
    import "quill/dist/quill.core.css";
    import "quill/dist/quill.snow.css";
    import "quill/dist/quill.bubble.css";
    import Quill from "quill";
    import { container, ImageExtend, QuillWatch } from "@/utils/QuillUtil";
    Quill.register("modules/ImageExtend", ImageExtend);
    export default {
        name: "MessageNotice",
        data() {
            return {
                mNotice: {},
            }
        },
        mounted() {
            let _mNotice = this.$route.query.mNotice;
            this.mNotice = _mNotice;
            this.initializeQuill();
        },
        methods: {
            /*
            * 发布通知消息
            * */
            submitForm(mNotice) {
                let that = this;
                let _isEdit = that.$route.query.isEdit;
                console.log("------", typeof _isEdit);
                let _url = "";
                if (_isEdit == 0) {
                    _url = "/msg/notice/edit";
                } else if (_isEdit == 1) {
                    _url = "/msg/notice/save";
                }
                that.HttpConnection.post(_url, that.mNotice).then(function(response) {
                    that.$message({
                        type: "success",
                        message: "操作成功!"
                    });
                    that.$router.back(-1);
                });
            },
            initializeQuill() {
                let that = this;
                let _quill = new Quill(this.$refs.editor, {
                    theme: "snow",
                    boundary: document.body,
                    modules: {
                        ImageExtend: {
                            loading: true,
                            name: "file",
                            action: process.env.VUE_APP_PREFIX + "/fastdfs/upload/image/sample",
                            headers: (xhr) => {
                                xhr.setRequestHeader("Authorization", Auth.getToken());
                                return xhr;
                            },
                            response: (res) => {
                                return process.env.VUE_APP_imagePath + res.filePath;
                            }
                        },
                        toolbar: {
                            container: container,
                            handlers: {
                                "image": function(value) {
                                    QuillWatch.emit(this.quill.id);
                                }
                            }
                        }
                    },
                    placeholder: "Insert text here ...",
                    readOnly: false
                });
                _quill.on("selection-change", range => {
                    // console.log("selection-change---->");
                });
                _quill.on("text-change", (delta, oldDelta, source) => {
                    let _html = that.$refs.editor.children[0].innerHTML;
                    let _text = _quill.getText();
                    that.mNotice.noticeContent = _html;
                });
                _quill.root.innerHTML = that.mNotice.noticeContent;
                //  自定义粘贴图片功能,将粘贴的图片传到后端
                /*
                _quill.root.addEventListener("paste", evt => {
                    if (evt.clipboardData && evt.clipboardData.files && evt.clipboardData.files.length) {
                        evt.preventDefault();
                        [].forEach.call(evt.clipboardData.files, file => {
                            if (!file.type.match(/^image\/(gif|jpe?g|a?png|bmp)/i)) {
                                return;
                            }
                            // 上传图片文件
                            let formData = new FormData();
                            formData.append("reportfile", file);
                            this.HttpConnection.post("/learn/report/imageUpload", formData, {
                                "Content-Type": "multipart/form-data"
                            }).then(resp => {
                                var range = _quill.getSelection();
                                if (range) {
                                    _quill.insertEmbed(range.index, "image", "/api" + resp.imgUrl); // 在当前光标位置插入图片
                                    _quill.setSelection(range.index + 1); // 将光标移动到图片后面
                                }
                            });
                        });
                    }
                }, false);*/
            },
            goBackTap() {
                this.$router.back(-1);
            }
        }
    };
</script>

<style scoped lang="scss">
    .ql-container{
        height: 200px;
    }

</style>
